export const CoreDataSecurityMonitorsByApplicationName = 'CoreDataSecurityMonitorsByApplication';
